"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=emote-definition.js.map